type FlattenedObject = Record<string, string | number | boolean | null | undefined>;

export const flattenObject = (obj: Record<string, any> | undefined): FlattenedObject => {
  if (!obj) return {};

  let result: FlattenedObject = {};

  for (const key in obj) {
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      const innerObj = flattenObject(obj[key]);
      Object.assign(result, innerObj);
    } else {
      const value = obj[key];
      result[key] = typeof value === 'number' ? value.toLocaleString() : value;
    }
  }

  return result;
};
